import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Checkbox, Input, ListItemText, Select, TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import clsx from 'clsx';
import Tooltip from '@mui/material/Tooltip';
import FormHelperText from '@mui/material/FormHelperText';
const PREFIX = 'ExtendedMultiChoiceField';

const classes = {
  fixLabel: `${PREFIX}-fixLabel`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.fixLabel}`]: {
    transform: 'translate(14px, 12px) scale(1)',
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ExtendedMultiChoiceField = forwardRef((props, ref) => {
  const { field: f, data: initial, autoFocus, errors, onChange } = props;
  const [error, setError] = useState();
  const inputRef = useRef();

  const takeDefaultValue = () => {
    if (initial.extended && initial.extended[f.name]) {
      const defaultValue = initial.extended[f.name].split(',');
      const a = [];
      const b = [];
      defaultValue.map(t => {
        if (f.options.indexOf(t) !== -1) {
          a.push(t);
        } else {
          b.push(t);
        }
      });
      if (b.length > 0) {
        setError('Этих полей больше не существует ' + b.join(', '));
      }
      return a;
    }
    return [];
  };

  const [selectedOptions, setSelectedOptions] = useState(takeDefaultValue);
  const selectedOptionsLower = selectedOptions.map(v => v.toLowerCase());

  useImperativeHandle(ref, () => ({
    fillValue: data => {
      data.extended = data.extended || {};
      if (inputRef.current.value) {
        data.extended[f.name] = inputRef.current.value.join(',').trim();
      } else {
        data.extended[f.name] = ''.trim();
      }

      return true;
    },
  }));

  const handleChange = event => {
    onChange(event.target.value, inputRef);
    const {
      target: { value },
    } = event;
    setSelectedOptions(typeof value === 'string' ? value.split(',') : value);
  };

  const hasChoice = () => {
    if (f.options.length === 1 && f.options[0] === '') {
      return false;
    }
    if (!f.options) {
      return false;
    }
    return true;
  };

  return (
    <Root>
      <FormControl variant='outlined' fullWidth style={{ marginTop: 8 }}>
        <InputLabel className={clsx(selectedOptions.length === 0 && classes.fixLabel)}>{f.label}</InputLabel>
        <Select
          multiple
          inputRef={inputRef}
          value={selectedOptions}
          onChange={handleChange}
          input={<OutlinedInput label={f.label} style={{ height: 40 }} />}
          renderValue={selected => selected.join(', ')}
          disabled={!hasChoice()}
          error={!!errors['extended.' + f.name]}
          // defaultValue={takeDefaultValue() || ""}
        >
          {f.options.map(it => (
            <MenuItem key={it.toLowerCase()} value={it.toLowerCase()} style={{}}>
              <Checkbox checked={selectedOptionsLower.indexOf(it.toLowerCase()) > -1} />
              <ListItemText primary={it} />
            </MenuItem>
          ))}
        </Select>
        <div style={{ color: 'red', fontSize: '12px' }}>{error}</div>
      </FormControl>
    </Root>
  );
});

export default ExtendedMultiChoiceField;
